// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValueHistoryChart_chartContainer__9PBh4 {
  width: 100%;
  min-width: 0;
}

.ValueHistoryChart_chart__NgZ9B {
  display: block;
  width: 100%;
  min-height: 280px;
}

.ValueHistoryChart_gridLine__x0Wzv {
  stroke: #e4e9ed;
  stroke-width: 1;
  stroke-dasharray: 3 4;
}

.ValueHistoryChart_axisLabel__UxSeO,
.ValueHistoryChart_monthLabel__WeOzi {
  fill: #667784;
  font-size: 12px;
}

.ValueHistoryChart_monthLabel__WeOzi {
  font-size: 13px;
}

.ValueHistoryChart_legend__ElvT2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px 22px;
  margin-top: 4px;
  color: #61717d;
  font-size: .82rem;
}

.ValueHistoryChart_legend__ElvT2 span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.ValueHistoryChart_legend__ElvT2 i {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex: 0 0 12px;
}

.ValueHistoryChart_empty__d0LfK {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  color: #71808b;
}

@media (max-width: 760px) {
  .ValueHistoryChart_chart__NgZ9B {
    min-width: 680px;
  }

  .ValueHistoryChart_chartContainer__9PBh4 {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/ValueHistoryChart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".chartContainer {\n  width: 100%;\n  min-width: 0;\n}\n\n.chart {\n  display: block;\n  width: 100%;\n  min-height: 280px;\n}\n\n.gridLine {\n  stroke: #e4e9ed;\n  stroke-width: 1;\n  stroke-dasharray: 3 4;\n}\n\n.axisLabel,\n.monthLabel {\n  fill: #667784;\n  font-size: 12px;\n}\n\n.monthLabel {\n  font-size: 13px;\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 10px 22px;\n  margin-top: 4px;\n  color: #61717d;\n  font-size: .82rem;\n}\n\n.legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.legend i {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex: 0 0 12px;\n}\n\n.empty {\n  display: flex;\n  min-height: 220px;\n  align-items: center;\n  justify-content: center;\n  color: #71808b;\n}\n\n@media (max-width: 760px) {\n  .chart {\n    min-width: 680px;\n  }\n\n  .chartContainer {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `ValueHistoryChart_chartContainer__9PBh4`,
	"chart": `ValueHistoryChart_chart__NgZ9B`,
	"gridLine": `ValueHistoryChart_gridLine__x0Wzv`,
	"axisLabel": `ValueHistoryChart_axisLabel__UxSeO`,
	"monthLabel": `ValueHistoryChart_monthLabel__WeOzi`,
	"legend": `ValueHistoryChart_legend__ElvT2`,
	"empty": `ValueHistoryChart_empty__d0LfK`
};
export default ___CSS_LOADER_EXPORT___;
